import store from "../../store";
import CONFIG from "../../config";
import { metalsActions, basketActions, currenciesActions } from "../../actions";
import console from "./console";
import sendError from "./sendError";

const state = {
  loaded: false,
  initialized: false,
  error: null
};

export const dataLoader = async (RouterMatch, parent) => {
  const { configStorage } = store.getState();
  const dispatch = store.dispatch;
  const dataAction = CONFIG.getShopConfig({
    edelmetall: metalsActions,
    sorten: currenciesActions
  });
  let error = null;
  console.log("data loader", RouterMatch, parent, state, configStorage.getSessionId());
  if (parent && parent.parentMatch) error = await parent.parentMatch.loaderPromise;
  console.log("data loader", configStorage.getSessionId());
  if (!state.loaded && !error && !state.error && configStorage.isDataLoaderActive()) {
    await Promise.all([
      dispatch(dataAction.fetchBaseData(configStorage.getRequestData("basedata"))),
      dispatch(dataAction.fetchListData(configStorage.getRequestData("catalog"))),
      dispatch(basketActions.setCurrentShopIsAnkauf(configStorage.isAnkaufShop()))
    ])
      .then(result => {
        state.loaded = true;
        state.error = null;
      })
      .catch(err => {
        if (Array.isArray(err)) {
          err.forEach(e => {
            if (e) sendError(e, "data-loader");
          });
        } else {
          sendError(err, "data-loader");
        }
        console.error("e3", err);
        state.error = err;
        state.loaded = false;
        error = new Error("e12: Ein Übertragungsfehler ist aufgetreten");
      });
  }
  if (error && error.message) {
    sendError(error, "data-loader");
    return error;
  }
  return null;
};

export default dataLoader;
